// Admin Imports
import Profile from "views/admin/profile";
import Organizations from "views/admin/organizations";
import Companies from "views/admin/companies/Companies";
import Users from "views/admin/users";
import Responders from "views/admin/responders";
import Groups from "views/admin/groups";
import AdminDashboard from "views/admin/dashboard/AdminDashboard";
import AdminLicenses from "views/admin/licenses/AdminLicenses";
import SettingsPage from "views/admin/settings/SettingsPage";
import Forms from "views/admin/forms/Forms";
import AdminOrganizationPlans from "views/admin/licenses/AdminOrganizationPlans";
import AdminLicensePlans from "views/admin/licenses/AdminLicensePlans";
import Requests from "views/admin/requests";

// Company Imports
import RespondingPage from "views/company/companies/responding/Responding";
import AssessmentList from "views/company/assessments/AssessmentList";
import LicensesPage from "views/company/licenses/LicensesPage";
import TransactionsPage from "views/company/transactions/TransactionsPage";
import AssessmentReport from "views/company/assessments/report/AssessmentReport";
import CompanyView from "views/company";
import AssessmentDetail from "views/company/assessments/detail/AssessmentDetail";
import CompanyModule from "views/admin/companies/components/CompanyModule";

// Responder Imports
import AssessmentPage from "views/responder/AssessmentPage";

// Organization Imports
import OrganizationDashboard from "views/organization/OrganizationDashboard";
import CompanyVerifications from "views/organization/CompanyVerifications";
import OrganizationResponding from "views/organization/OrganizationResponding";
import OrganizationAssessmentPage from "views/organization/OrganizationAssessmentPage";
import OrganizationAssessmentReport from "views/organization/OrganizationAssessmentReport";

import { UserRole } from "types/userTypes";

// Icon Imports
import {
  MdOutlineGroupWork,
  MdOutlineAssessment,
  MdOutlineDashboard,
  MdOutlineVerified,
} from "react-icons/md";
import { GoKey, GoOrganization } from "react-icons/go";
import { HiOutlineHomeModern } from "react-icons/hi2";
import { PiUsersThree } from "react-icons/pi";
import { FiUsers } from "react-icons/fi";
import { IoHomeOutline, IoSettingsOutline } from "react-icons/io5";
import { CgProfile } from "react-icons/cg";
import { BsBuildingAdd, BsBuildings, BsInbox } from "react-icons/bs";
import { AiOutlineTransaction } from "react-icons/ai";
import { FaUsersGear, FaWpforms } from "react-icons/fa6";
import { SlOrganization } from "react-icons/sl";
import { TbLicense } from "react-icons/tb";
import { LuBox } from "react-icons/lu";
import { CiSquareQuestion } from "react-icons/ci";

const routes = [
  // admin
  {
    name: "adminDashboard",
    layout: "/admin",
    path: "dashboard",
    icon: <IoHomeOutline size={22} />,
    component: <AdminDashboard />,
    roles: [UserRole.ADMIN],
    show: true,
  },
  {
    name: "users",
    layout: "/admin",
    path: "users",
    icon: <PiUsersThree size={22} />,
    component: <Users />,
    roles: [UserRole.ADMIN],
    show: true,
  },
  {
    name: "organizations",
    layout: "/admin",
    path: "organizations",
    icon: <GoOrganization size={22} />,
    component: <Organizations />,
    roles: [UserRole.ADMIN],
    show: true,
  },
  {
    name: "companyList",
    layout: "/admin",
    icon: <BsBuildings size={20} />,
    path: "companies/list",
    component: <Companies />,
    roles: [UserRole.ADMIN],
    show: true,
  },
  {
    name: "view",
    layout: "/admin",
    path: "companies/:id/view",
    component: <CompanyModule key="view" mode="view" />,
    show: false,
  },
  {
    name: "assessments",
    layout: "/admin",
    path: "assessments",
    icon: <MdOutlineAssessment size={22} />,
    component: <AssessmentList />,
    roles: [UserRole.ADMIN],
    show: true,
  },
  {
    name: "assessmentDetail",
    layout: "/admin",
    path: "assessment/:id/detail",
    icon: <MdOutlineAssessment size={22} />,
    component: <AssessmentDetail />,
    roles: [UserRole.ADMIN],
    show: false,
  },
  {
    name: "assessmentReport",
    layout: "/admin",
    path: "assessment/:id/report",
    icon: <MdOutlineAssessment size={22} />,
    component: <AssessmentReport />,
    roles: [UserRole.ADMIN],
    show: false,
  },
  {
    name: "responders",
    layout: "/admin",
    path: "responders",
    icon: <FiUsers size={22} />,
    component: <Responders />,
    roles: [UserRole.ADMIN],
    show: true,
  },
  {
    name: "organizationAssessment",
    layout: "/admin",
    path: "organization-assessment",
    icon: <SlOrganization size={22} />,
    component: <OrganizationAssessmentPage />,
    roles: [UserRole.ADMIN],
    show: true,
  },
  {
    name: "organizationAssessmentReport",
    layout: "/admin",
    path: "organization-assessment/:id/report",
    component: <OrganizationAssessmentReport />,
    roles: [UserRole.ADMIN],
    show: false,
  },
  {
    name: "requests",
    layout: "/admin",
    path: "requests",
    icon: <CiSquareQuestion size={22} />,
    component: <Requests />,
    roles: [UserRole.ADMIN],
    show: true,
  },
  {
    name: "transactions",
    layout: "/admin",
    path: "transactions",
    icon: <AiOutlineTransaction size={22} />,
    component: <TransactionsPage />,
    roles: [UserRole.ADMIN],
    show: true,
  },
  {
    name: "adminLicenseList",
    layout: "/admin",
    path: "licenses",
    icon: <TbLicense size={22} />,
    component: <AdminLicenses />,
    roles: [UserRole.ADMIN],
    show: true,
  },
  {
    name: "information",
    layout: "/admin",
    path: "information",
    icon: <HiOutlineHomeModern size={22} />,
    roles: [UserRole.ADMIN],
    show: true,
    children: [
      {
        name: "groups",
        layout: "/admin",
        path: "groups",
        icon: <MdOutlineGroupWork size={22} />,
        component: <Groups />,
        roles: [UserRole.ADMIN],
        show: true,
      },
      {
        name: "forms",
        layout: "/admin",
        path: "forms",
        icon: <FaWpforms size={22} />,
        component: <Forms />,
        roles: [UserRole.ADMIN],
        show: true,
      },
      {
        name: "organizationLicensePlans",
        layout: "/admin",
        path: "organization-plans",
        icon: <LuBox size={22} />,
        component: <AdminOrganizationPlans />,
        roles: [UserRole.ADMIN],
        show: true,
      },
      {
        name: "licensePlans",
        layout: "/admin",
        path: "license-plans",
        icon: <BsInbox size={22} />,
        component: <AdminLicensePlans />,
        roles: [UserRole.ADMIN],
        show: true,
      },
      {
        name: "settings",
        layout: "/admin",
        path: "settings",
        icon: <IoSettingsOutline size={22} />,
        component: <SettingsPage />,
        roles: [UserRole.ADMIN],
        show: true,
      },
    ],
  },
  {
    name: "profile",
    layout: "/admin",
    path: "profile",
    icon: <CgProfile size={22} />,
    component: <Profile />,
    roles: [UserRole.ADMIN],
    show: true,
  },

  // company
  {
    name: "home",
    layout: "/company",
    path: "dashboard",
    icon: <MdOutlineDashboard size={22} />,
    component: <CompanyView />,
    roles: [UserRole.USER],
    show: true,
  },
  {
    name: "companies",
    layout: "/company",
    path: "companies",
    icon: <HiOutlineHomeModern size={22} />,
    roles: [UserRole.USER],
    show: true,
    children: [
      {
        name: "companyCreate",
        layout: "/company",
        icon: <BsBuildingAdd size={20} />,
        path: "companies/create",
        component: <CompanyModule key="create" mode="create" />,
        roles: [UserRole.USER],
        show: true,
      },
      {
        name: "companyList",
        layout: "/company",
        icon: <BsBuildings size={20} />,
        path: "companies/list",
        component: <Companies />,
        roles: [UserRole.USER],
        show: true,
      },
      {
        name: "view",
        layout: "/company",
        path: "companies/:id/view",
        component: <CompanyModule key="view" mode="view" />,
        show: false,
      },
      {
        name: "edit",
        layout: "/company",
        path: "companies/:id/edit",
        component: <CompanyModule key="edit" mode="edit" />,
        show: false,
      },
      {
        name: "responding",
        layout: "/company",
        path: "companies/:id/responding",
        component: <RespondingPage />,
        show: false,
      },
    ],
  },
  {
    name: "assessments",
    layout: "/company",
    path: "assessments",
    icon: <MdOutlineAssessment size={22} />,
    component: <AssessmentList />,
    roles: [UserRole.USER],
    show: true,
  },
  {
    name: "assessmentDetail",
    layout: "/company",
    path: "assessment/:id/detail",
    icon: <MdOutlineAssessment size={22} />,
    component: <AssessmentDetail />,
    roles: [UserRole.USER],
    show: false,
  },
  {
    name: "assessmentReport",
    layout: "/company",
    path: "assessment/:id/report",
    icon: <MdOutlineAssessment size={22} />,
    component: <AssessmentReport />,
    roles: [UserRole.USER],
    show: false,
  },
  {
    name: "licenses",
    layout: "/company",
    path: "licenses",
    icon: <GoKey size={22} />,
    component: <LicensesPage />,
    roles: [UserRole.USER],
    show: true,
  },
  {
    name: "transactions",
    layout: "/company",
    path: "transactions",
    icon: <AiOutlineTransaction size={22} />,
    component: <TransactionsPage />,
    roles: [UserRole.USER],
    show: true,
  },
  {
    name: "profile",
    layout: "/company",
    path: "profile",
    icon: <CgProfile size={22} />,
    component: <Profile />,
    roles: [UserRole.USER],
    show: true,
  },

  // organization
  {
    name: "organizationDashboard",
    layout: "/organization",
    path: "dashboard",
    icon: <MdOutlineDashboard size={22} />,
    component: <OrganizationDashboard />,
    roles: [UserRole.USER],
    show: true,
  },
  {
    name: "organizationCompanies",
    layout: "/organization",
    path: "companies",
    icon: <HiOutlineHomeModern size={22} />,
    roles: [UserRole.USER],
    show: true,
    children: [
      {
        name: "companyVerifications",
        layout: "/organization",
        icon: <MdOutlineVerified size={20} />,
        path: "companies/verification",
        component: <CompanyVerifications />,
        roles: [UserRole.USER],
        show: true,
        needVerify: true,
      },
      {
        name: "organizationCompanyList",
        layout: "/organization",
        icon: <BsBuildings size={20} />,
        path: "companies/list",
        component: <Companies />,
        roles: [UserRole.USER],
        show: true,
      },
      {
        name: "view",
        layout: "/organization",
        path: "companies/:id/view",
        component: <CompanyModule key="view" mode="view" />,
        show: false,
      },
    ],
  },
  {
    name: "organizationCompaniesAssessments",
    layout: "/organization",
    path: "assessments",
    icon: <MdOutlineAssessment size={22} />,
    component: <AssessmentList />,
    roles: [UserRole.USER],
    show: true,
  },
  {
    name: "assessmentReport",
    layout: "/organization",
    path: "assessment/:id/report",
    component: <AssessmentReport />,
    roles: [UserRole.USER],
    show: false,
  },
  {
    name: "organizationResponding",
    layout: "/organization",
    path: "responding",
    icon: <FaUsersGear size={22} />,
    component: <OrganizationResponding />,
    roles: [UserRole.USER],
    show: true,
    form: true,
  },
  {
    name: "organizationAssessment",
    layout: "/organization",
    path: "organization-assessment",
    icon: <SlOrganization size={22} />,
    component: <OrganizationAssessmentPage />,
    roles: [UserRole.USER],
    show: true,
    form: true,
  },
  {
    name: "organizationAssessmentReport",
    layout: "/organization",
    path: "organization-assessment/:id/report",
    component: <OrganizationAssessmentReport />,
    roles: [UserRole.USER],
    show: false,
    form: true,
  },
  {
    name: "organizationLicenses",
    layout: "/organization",
    path: "licenses",
    icon: <GoKey size={22} />,
    component: <LicensesPage />,
    roles: [UserRole.USER],
    show: true,
  },
  {
    name: "organizationTransactions",
    layout: "/organization",
    path: "transactions",
    icon: <AiOutlineTransaction size={22} />,
    component: <TransactionsPage />,
    roles: [UserRole.USER],
    show: true,
  },
  {
    name: "profile",
    layout: "/organization",
    path: "profile",
    icon: <CgProfile size={22} />,
    component: <Profile />,
    roles: [UserRole.USER],
    show: true,
  },

  // responding
  {
    name: "response",
    layout: "/assessment",
    path: "/",
    component: <AssessmentPage />,
    show: false,
  },
];
export default routes;
